import React from 'react';
import cn from 'classnames';
import './UtilityForm.scss';

const FormCard = ({ children }) => <div className={cn('form-card')}>{children}</div>;

export default FormCard;
